globalThis.appCustomerSpace = globalThis.appCustomerSpace || {};
appCustomerSpace.Controllers = appCustomerSpace.Controllers || {};
appCustomerSpace.Controllers.Reviews = appCustomerSpace.Controllers.Reviews || {};

appCustomerSpace.Controllers.Reviews.MainController = (function(superClass) {

    utils.extend(MainController, superClass);

    function MainController() {
        return MainController.__super__.constructor.apply(this, arguments);
    }

    $.extend(MainController.prototype, {
        init: function(){
            appCustomerSpace.Modules.Reviews.Reply = new appCustomerSpace.Modules.Reviews.Reply();

            return MainController.__super__.init.apply(this, arguments);
        }
    });

    return MainController;

})(appCustomerSpace.Controllers.MainController);
